(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-master-faq"]) return;
  try {
    
(function(){
'use strict';
const root=document.getElementById('gb-master');if(!root||root.dataset.enhanced)return;root.dataset.enhanced='true';
const items=Array.from(root.querySelectorAll('details.gb-question'));
const sections=Array.from(root.querySelectorAll('.gb-section'));
const input=root.querySelector('#gb-search-input'),status=root.querySelector('#gb-result-status'),empty=root.querySelector('#gb-no-results');
const stop=new Set('a an the and or can could do does did how what when where why is are am i you my your me we our to in on for of with at it be have has will would please about this that any after before'.split(' '));
function norm(s){return s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\bturkey\b/g,'turkiye').replace(/\bcolours?\b/g,'color').replace(/\binstalments?\b/g,'installments').replace(/\breimburse\w*/g,'refund').replace(/[^a-z0-9]+/g,' ').trim();}
const index=new Map(items.map(el=>[el,norm(el.textContent+' '+el.dataset.aliases+' '+el.dataset.scope)]));
function applySearch(){
 const tokens=norm(input.value).split(' ').filter(t=>t&&!stop.has(t));let n=0;
 items.forEach(el=>{const hay=index.get(el);const match=tokens.every(t=>hay.includes(t));el.hidden=!match;if(match)n++;if(tokens.length)el.open=match;});
 sections.forEach(s=>{s.hidden=!s.querySelector('details.gb-question:not([hidden])');const overview=s.querySelector('.gb-overview');if(overview)overview.hidden=Boolean(tokens.length);});
 empty.hidden=n!==0;status.textContent=tokens.length?n+' of '+items.length+' answers match your search':items.length+' answers across '+sections.length+' topics';
 root.dataset.searching=tokens.length?'true':'false';
}
input.disabled=false;root.querySelectorAll('[data-js-control]').forEach(el=>el.hidden=false);
let timer;input.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(applySearch,150);});
function clear(){input.value='';clearTimeout(timer);applySearch();}
root.querySelectorAll('[data-clear-search]').forEach(b=>b.addEventListener('click',()=>{clear();items.forEach(el=>el.open=false);input.focus();}));
root.querySelector('[data-expand]').addEventListener('click',()=>items.filter(el=>!el.hidden).forEach(el=>el.open=true));
root.querySelector('[data-collapse]').addEventListener('click',()=>items.forEach(el=>el.open=false));
root.querySelector('[data-print]').addEventListener('click',()=>window.print());
function revealHash(){let id;try{id=decodeURIComponent(location.hash.slice(1));}catch(_){return;}const el=document.getElementById(id);if(!el||!root.contains(el))return;if(input.value)clear();if(el.matches('details.gb-question'))el.open=true;setTimeout(()=>el.scrollIntoView({block:'start',behavior:'auto'}),20);}
root.addEventListener('click',e=>{const a=e.target.closest('a[href^="#"]');if(a&&root.contains(a)){if(input.value)clear();const t=document.getElementById(a.getAttribute('href').slice(1));if(t&&t.matches('details.gb-question'))t.open=true;}});
window.addEventListener('hashchange',revealHash);
let printState=null;
window.addEventListener('beforeprint',()=>{printState={items:items.map(el=>({open:el.open,hidden:el.hidden})),sections:sections.map(el=>el.hidden),overview:sections.map(el=>el.querySelector('.gb-overview')?.hidden)};items.forEach(el=>{el.hidden=false;el.open=true;});sections.forEach(el=>{el.hidden=false;const o=el.querySelector('.gb-overview');if(o)o.hidden=false;});});
window.addEventListener('afterprint',()=>{if(!printState)return;items.forEach((el,i)=>{el.open=printState.items[i].open;el.hidden=printState.items[i].hidden;});sections.forEach((el,i)=>{el.hidden=printState.sections[i];const o=el.querySelector('.gb-overview');if(o)o.hidden=printState.overview[i];});printState=null;});
items.forEach(el=>el.addEventListener('toggle',()=>{if(el.open)root.dispatchEvent(new CustomEvent('gb:faq-open',{bubbles:true,detail:{articleId:el.id,topicId:el.closest('.gb-section').id}}));}));
applySearch();if(location.hash)revealHash();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gbx-404"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  if(window.gb404RecoveryLoaded)return;
  window.gb404RecoveryLoaded=true;
  var pending=0;
  function measure(){
    pending=0;
    var main=document.getElementById('mainContent');
    if(!main||!main.querySelector('[data-gb404]'))return;
    var offset=Math.max(0,Math.round(main.getBoundingClientRect().top+window.scrollY));
    document.documentElement.style.setProperty('--gb404-shell',offset+'px');
  }
  function schedule(){if(!pending)pending=window.requestAnimationFrame(measure);}
  function start(){
    if(!document.querySelector('[data-gb404]'))return;
    schedule();
    if('ResizeObserver' in window){
      var observer=new ResizeObserver(schedule);
      ['shopify-section-header','shopify-section-announcement'].forEach(function(id){var el=document.getElementById(id);if(el)observer.observe(el);});
    }
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(schedule);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('load',schedule,{once:true});
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('click',function(event){
    if(!(event.target instanceof Element))return;
    var link=event.target.closest('[data-gb404] a[data-gbx-action]');
    if(!link)return;
    document.dispatchEvent(new CustomEvent('gb404:navigate',{detail:{action:link.dataset.gbxAction,version:'2026-09-08-v1'}}));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gbx-contact"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  if(window.gbContactLauncherLoaded)return;
  window.gbContactLauncherLoaded=true;
  var busy=false;
  function visible(el){
    if(!el||!el.isConnected)return false;
    var style=getComputedStyle(el);
    return style.display!=='none'&&style.visibility!=='hidden'&&el.getClientRects().length>0;
  }
  function scopesFor(host){
    var scopes=[host];
    if(host.shadowRoot)scopes.push(host.shadowRoot);
    for(var i=0;i<scopes.length&&i<20;i++){
      var nodes=scopes[i].querySelectorAll('*');
      for(var j=0;j<nodes.length;j++)if(nodes[j].shadowRoot&&scopes.indexOf(nodes[j].shadowRoot)===-1)scopes.push(nodes[j].shadowRoot);
    }
    return scopes;
  }
  function inspect(){
    var hosts=document.querySelectorAll('inbox-online-store-chat,shopify-chat,#ShopifyChat');
    for(var i=0;i<hosts.length;i++){
      var host=hosts[i],scopes=scopesFor(host),button=null,opened=host.getAttribute('is-open')==='true';
      for(var j=0;j<scopes.length;j++){
        var dialogs=scopes[j].querySelectorAll('[role="dialog"],dialog[open]');
        for(var k=0;k<dialogs.length;k++)if(visible(dialogs[k]))opened=true;
        var buttons=scopes[j].querySelectorAll('button.chat-toggle,button.activator');
        for(var b=0;b<buttons.length;b++){
          if(buttons[b].getAttribute('aria-expanded')==='true')opened=true;
          if(!button&&visible(buttons[b])&&!buttons[b].disabled)button=buttons[b];
        }
      }
      if(opened||button)return {host:host,button:button,opened:opened};
    }
    return null;
  }
  function enable(root){root.querySelectorAll('[data-gbc-open]').forEach(function(b){b.disabled=false;});}
  function init(){document.querySelectorAll('[data-gb-contact]').forEach(enable);}
  function launch(button,root){
    if(busy)return;
    busy=true;
    var status=root.querySelector('[data-gbc-status]'),hint=root.querySelector('[data-gbc-hint]');
    var start=Date.now(),clicked=false;
    root.querySelectorAll('[data-gbc-open]').forEach(function(b){b.disabled=true;});
    status.hidden=false;status.textContent=root.dataset.opening;
    hint.hidden=!button.dataset.hint;hint.textContent=button.dataset.hint||'';
    function finish(key){status.textContent=root.dataset[key];busy=false;enable(root);}
    function attempt(){
      if(!root.isConnected){busy=false;return;}
      var chat=inspect();
      if(chat&&chat.opened){finish('opened');return;}
      if(chat&&chat.button&&!clicked){
        clicked=true;
        try{chat.button.click();}catch(error){finish('unavailable');return;}
        window.setTimeout(function(){
          var result=inspect();
          finish(result&&result.opened?'opened':'unconfirmed');
        },450);
        return;
      }
      if(Date.now()-start<6000)window.setTimeout(attempt,250);else finish('unavailable');
    }
    attempt();
  }
  document.addEventListener('click',function(event){
    if(!(event.target instanceof Element))return;
    var button=event.target.closest('[data-gbc-open]');
    if(!button)return;
    var root=button.closest('[data-gb-contact]');
    if(root)launch(button,root);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
